import { useTranslation } from "react-i18next";

import { Column, Columns, Skeleton, Spacer, Typography } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { l } from "@unauthenticated/oauth/locales/i18n";

import * as styles from "./OAuthLandingPage.styles";

const SkeletonOAuthLandingPage = () => {
  const { t } = useTranslation();
  const { phoneLarge } = useBreakpoints();

  return (
    <div css={styles.body}>
      <Typography type="h2">{t(l.oauth.AreYouNew)}</Typography>
      <Typography>{t(l.oauth.PickOneOf)}</Typography>
      <Spacer height="quad" />

      <Columns>
        <Column columnWidth={6}>
          <Skeleton isFullWidth height={15} />
        </Column>
        <Column columnWidth={6}>
          <Skeleton isFullWidth height={15} />
        </Column>
      </Columns>

      <div css={styles.button}>
        <Skeleton type="button" isFullWidth={phoneLarge.lessThan} />
      </div>
    </div>
  );
};

export { SkeletonOAuthLandingPage };
